<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="item-list">
    <div
      v-for="el in dataTable"
      :key="el.name"
      class="element-li"
    >
      <div class="horizontal-separator" />
      <div class="element-camp">
        <span>{{ el.name }}</span>
      </div>
      <div class="element-descript">
        <span v-html="el.desc" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Display document table example
 * @example [none]
 */
export default {
  name: 'ItemList',
  components: {},
  props: {
    /**
     * Array of objects in the list
     */
    dataTable: {
      type: Array,
    },
  },
}
</script>

<style lang="stylus" scoped>
.item-list
  display: flex
  flex-direction: column
  margin-top: vw(20px)
  width: 100%

  .element-li
    display: flex
    flex-direction: column

    .horizontal-separator
      margin: vw(15px) 0
      width: vw(30px)
      height: 1px
      border-bottom: 1px solid $bcn-grey-3

    .element-camp
      width: 35%

      span
        color: black
        m-font-size(18, 26)
        font-weight: 400

    .element-descript
      width: 65%

      .mobile &
        width: 100%

      span
        color: $grey
        m-font-size(16, 24)
        font-weight: 300
</style>